import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Paper from 'material-ui/Paper';

import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import DatePicker from 'material-ui/DatePicker';
import TextField from 'material-ui/TextField';
//import Slider from 'material-ui/Slider';

//import AppConstants from '../../constants/AppConstants';
import isEmpty from 'validator/lib/isEmpty';

import Fetcher from '../../util/fetcher';
import PoiFormRadiusChar from '../../components/PoiFormRadiusChar';

import StepProps from '../../constants/StepProps';

const styles = {
  flexBox: {
    display: 'flex'
  },
  flexBig: {
    flex: '2 0 0',
    margin: 8,
  },
  flexSmall: {
    flex: '1 0 0',
    margin: 8,
  },
  checkbox: {
    marginLeft: 12,
  },
  timeLabel: {
    color: '#aaa',
  },
  labelStyle: {
    // color: AppConstants.colors.primary2Color,
  },
  minLableStyle: {
    color: '#aaa',
    fontSize: '12',
    textAlign: 'left',
  },
  maxLableStyle: {
    color: '#aaa',
    fontSize: '12',
    textAlign: 'right',
  }

};

const timeItems = {
  Night: '00:00 - 06:00',
  Morning: '06:00 - 12:00',
  Afternoon: '12:00 - 18:00',
  Evening: '18:00 - 00:00',
};

const today = new Date();
// add below date contraints because xmode cron job is disabled, see https://trello.com/c/vW1NEICT/
const startdate = new Date('2018-06-30');
const enddate = new Date('2018-07-27');
const defaultRange = Math.ceil((today.getTime() - enddate.getTime()) / (1000 * 3600 * 24));

function disableDates(date) {
  // temp changes because xmode cron job is disabled, see https://trello.com/c/vW1NEICT/
  return date.getTime() - startdate.getTime() < 0 || enddate.getTime() - date.getTime() < 0;
  // return date.getTime() - today.getTime() > 0 || today.getTime() - date.getTime() > (1000 * 3600 * 24 * 22);
}

class PoiStepSettings extends Component {
  static contextTypes = {
    dataset: PropTypes.string.isRequired,
    firebaseToken: PropTypes.string.isRequired,
    history: PropTypes.object.isRequired,
  };

  static propTypes = StepProps;

  state = {
    radius: '100', // in meters
    times: Object.keys(timeItems),
    setDate: enddate,
    frequency: '10',
    recency: defaultRange,
    disableYearSelection: true,
  }

  componentWillUpdate(nextProps, nextState, nextContext) {
    this.handleValidation(nextState);
  }

  componentDidMount() {
    this.handleValidation(this.state);
  }

  isFormValid(state = this.state) {
    let valid = false;
    valid = state.radius > 9 && state.radius < 1001 && state.times.length > 0 && !isEmpty(state.frequency);
    return valid;
  }

  handleValidation(state) {
    let nextFormValid = this.isFormValid(state);
    // If none are selected, we cannot continue.
    if (nextFormValid !== this.prevFormValid) {
      this.props.onValidationChange(nextFormValid);
      this.prevFormValid = nextFormValid;
    }
  }

  handleRadiusChange = (value) => {
    this.setState({
      radius: value,
    });
  }

  handleFrequencyChange = (event, value) => {
    this.setState({
      frequency: value,
    });
  }

  handleTimeChange = (event, index, values) => {
    this.setState({
      times: values,
    });
  }

  handleRecencyChange = (event, date) => {
    var timeDiff = Math.abs(date.getTime() - today.getTime());
    var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
    this.setState({
      setDate: date,
      recency: diffDays,
    });
  }

  /**
   * This is called when the next button is pressed in the AmpStepper component.
   * AmpStepper waits for validation from this component before proceeding
   */
  complete() {
    const {hash} = this.props;
    const {firebaseToken, dataset} = this.context;

    // Create form commands and send this to the back-end
    const data = {
      radius: this.state.radius,
      times: this.state.times,
      frequency: this.state.frequency,
      recency: this.state.recency,

    }

    // Start processing with the current configuration
    // We'll start polling the progress in the next step
    Fetcher.init(firebaseToken)
      .poiProcess(hash, data, dataset)
      .then(this.props.onStepCompleteSuccess)
      .catch(this.props.onStepCompleteFailed);
  }

  renderMenuItems(times) {
    return Object.keys(timeItems).map((time) => (
      <MenuItem
        key={time}
        insetChildren={true}
        checked={times && times.indexOf(time) > -1}
        value={time}
        primaryText={time}
        secondaryText={<span style={styles.timeLabel}>{timeItems[time]}</span>}
      />
    ));
  }

  render() {
    const {times} = this.state;
    return (
      <Paper zDepth={1} className="ContentSpacing" style={styles.flexBox}>
        <div style={styles.flexSmall}>
          <h3>Apply time filters</h3>
          <SelectField
            multiple={true}
            floatingLabelStyle={styles.labelStyle}
            floatingLabelFixed={true}
            floatingLabelText="Active in the"
            hintText="Select a time"
            value={times}
            onChange={this.handleTimeChange}
          >
            {this.renderMenuItems(times)}
          </SelectField>
          <br />
          <DatePicker
            hintText="Select a date"
            floatingLabelText="Last activity from"
            floatingLabelFixed={true}
            floatingLabelStyle={styles.labelStyle}
            defaultDate={this.state.setDate}
            disableYearSelection={this.state.disableYearSelection}
            shouldDisableDate={disableDates}
            onChange={this.handleRecencyChange}
          />
          <TextField
            hintText="Please input an integer"
            floatingLabelFixed={true}
            floatingLabelStyle={styles.labelStyle}
            floatingLabelText="Active more than n times"
            defaultValue={this.state.frequency}
            //value={this.state.frequency}
            onChange={this.handleFrequencyChange}
          />
      </div>
      <div style={styles.flexSmall}>
          <h3> Set radius</h3>
            <PoiFormRadiusChar
              onChange={this.handleRadiusChange}
              defaultValue={this.state.radius}
              showAuto={true}
            />
          {/* <p>
            <span>{'Match devices within '}</span>
            <span><strong>{this.state.radius}m </strong></span>
            <span>({meterToFeet(this.state.radius)} feet)  </span>
            <span>{'from uploaded geolocations.'}</span>
          </p>
          <Slider
            min={10}
            max={1000}
            step={10}
            value={this.state.radius}
            onChange={this.handleRadiusChange}
          />
          <p>
            <span style={styles.maxLableStyle}>Min: 10m</span>
            <span style={styles.maxLableStyle}>Max: 1000m</span>
          </p> */}
        </div>
      </Paper>
    );
  }
}
export default PoiStepSettings;



// WEBPACK FOOTER //
// ./src/components/PoiStepSettings/index.jsx